/**
 * How a walk names the person who walked it — ONE rule, used by the All Walks
 * list and by walk detail.
 *
 * Both used to spell it themselves as `creatorName || creator || "Unknown
 * walker"`, and both therefore printed a raw Clerk user id whenever the name
 * lookup missed. On staging that was every one of the 50 rows on All Walks.
 *
 * The id is not a degraded name, it is a different kind of thing: it tells the
 * reader nothing and it looks like a bug. "Unknown walker" is the honest
 * fallback, and it is what walk detail already said in the one branch that
 * reached it.
 *
 * Names collide — the real E2E org has two members whose Clerk profile name is
 * identically "Leo Li" — so a colliding name carries its email, the same way
 * `getPeople` and `getAdoption` disambiguate the same two people.
 */
export interface WalkerFields {
  creator?: string;
  creatorName?: string;
  creatorEmail?: string;
  creatorNameCollides?: boolean;
}

export function walkerLabel(walk: WalkerFields): string {
  const name = walk.creatorName?.trim();
  if (!name) return "Unknown walker";
  if (walk.creatorNameCollides && walk.creatorEmail) return `${name} · ${walk.creatorEmail}`;
  return name;
}
